// extracted by mini-css-extract-plugin
var _1 = "ra-search-visual-hint";
var _2 = "ra-search-visual-hint-suggestions";
export { _1 as "searchVisualHintCls", _2 as "searchVisualHintSuggestionsCls" }
